import React from 'react';
import {
  Labeled,
  BooleanField,
  FunctionField,
  TextField,
} from 'react-admin';

export default props => (
  <div style={{ display: 'flex', flexDirection: 'column' }}>
    <Labeled label="Disable Inbound Bank Transfer in Funnel (To: My IPO / Deposit)">
      <BooleanField
        source="appConfig.bankTransfer.disabledInboundFunnel"
        style={{ width: '100%' }}
        {...props}
      />
    </Labeled>
    <FunctionField
      {...props}
      label="Inbound Transfer Funnel Alert Text"
      render={innerRecord => innerRecord.appConfig &&
        innerRecord.appConfig.bankTransfer &&
        innerRecord.appConfig.bankTransfer.disabledInboundFunnel &&
          <Labeled label="Inbound Transfer Funnel Alert Text">
            <TextField
              component="pre"
              source="appConfig.bankTransfer.disabledInboundDisclaimerFunnel"
              style={{ 'white-space': 'pre-wrap' }}
              fullWidth
              multiline
              minRows={1}
              maxRows={4}
              {...props}
            />
          </Labeled>
      }
    />
    <Labeled label="Disable Outbound Bank Transfer in Funnel (From: My IPO / Withdrawal)" >
      <BooleanField
        source="appConfig.bankTransfer.disabledOutboundFunnel"
        style={{ width: '100%' }}
        {...props}
      />
    </Labeled>
    <FunctionField
      {...props}
      label="Inbound Transfer Funnel Alert Text"
      render={innerRecord => innerRecord.appConfig &&
        innerRecord.appConfig.bankTransfer &&
        innerRecord.appConfig.bankTransfer.disabledOutboundFunnel &&
          <Labeled label="Outbound Transfer Funnel Alert Text">
            <TextField
              component="pre"
              source="appConfig.bankTransfer.disabledOutboundDisclaimerFunnel"
              style={{ 'white-space': 'pre-wrap' }}
              fullWidth
              multiline
              minRows={1}
              maxRows={4}
              {...props}
            />
          </Labeled>
      }
    />
    <Labeled label="Disable Inbound Bank Transfer in Mobile (To: My IPO / Deposit)">
      <BooleanField
        source="appConfig.bankTransfer.disabledInboundMobile"
        style={{ width: '100%' }}
        {...props}
      />
    </Labeled>
    <FunctionField
      {...props}
      label="Inbound Transfer Mobile Alert Text"
      render={innerRecord => innerRecord.appConfig &&
        innerRecord.appConfig.bankTransfer &&
        innerRecord.appConfig.bankTransfer.disabledInboundMobile &&
          <Labeled label="Inbound Transfer Mobile Alert Text">
            <TextField
              component="pre"
              source="appConfig.bankTransfer.disabledInboundDisclaimerMobile"
              style={{ 'white-space': 'pre-wrap' }}
              fullWidth
              multiline
              minRows={1}
              maxRows={4}
              {...props}
            />
          </Labeled>
      }
    />
    <Labeled label="Disable Outbound Bank Transfer in Mobile (From: My IPO / Withdrawal)">
      <BooleanField
        source="appConfig.bankTransfer.disabledOutboundMobile"
        style={{ width: '100%' }}
        {...props}
      />
    </Labeled>
    <FunctionField
      {...props}
      label="Outbound Transfer Mobile Alert Text"
      render={innerRecord => innerRecord.appConfig &&
        innerRecord.appConfig.bankTransfer &&
        innerRecord.appConfig.bankTransfer.disabledOutboundMobile &&
          <Labeled label="Outbound Transfer Mobile Alert Text">
            <TextField
              component="pre"
              source="appConfig.bankTransfer.disabledOutboundDisclaimerMobile"
              style={{ 'white-space': 'pre-wrap' }}
              fullWidth
              multiline
              minRows={1}
              maxRows={4}
              {...props}
            />
          </Labeled>
      }
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Config/BankTransferConfig_Show.jsx